export default {"src":"/_next/static/media/caramel.fc7b63a6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};